import React from 'react'
import PropTypes from 'prop-types'
import {SearchCache} from "./SearchCache";
import {SearchRender} from "./SearchRender";


/**
 * Data component to manage searching and caching of results
 */
export class Search extends React.Component {
  static propTypes = {

    /**
     * function called when an option from the menu is selected
     * T => void
     */
    onSelected: PropTypes.func,

    /**
     * Optional function. if defined, called when a value has no results, and instead the user intends to create a value
     * from the current search (e.g. for a tag set)
     * string => void
     */
    onForceSelect: PropTypes.func,

    /**
     * function to fetch results
     * { query: string, offset: number } => Promise.<{items: Array.<*>, hasMore: boolean }>
     *
     */
    getSearchResults: PropTypes.func,

    /**
     * debounce delay for searching
     */
    delay: PropTypes.number,

    /**
     * component to render option. Required if the options are not renderable (e.g. not values or components)
     */
    renderOption: PropTypes.any,

    /**
     * function to get a key. Defaults to the options field at "value", "id", or the object itself
     * T => some kind of primitive value
     */
    getKey: PropTypes.func,

    /**
     * render component for this data component
     */
    Render: PropTypes.any,

    placeholder: PropTypes.string,

    /**
     * What search text value to set when a search item is selected. Defaults to clearing the input
     * (selection: T, currentValue: string) => void
     */
    valueOnSelect: PropTypes.func.isRequired

  }

  static defaultProps = {
    onSelected: (selected) => {},
    delay: 250,
    getSearchResults: ({ query, offset }) => Promise.resolve({ items: [], hasMore: false }),
    getKey: option => {

      if ('value' in (option || {})) {
        return option.value
      } else if ('id' in (option | {})) {
        return option.id
      } else {
        return option
      }
    },
    Render: SearchRender,
    renderOption: (thing) => thing,
    valueOnSelect: (selection, currentValue) => ''

  }

  state = {
    results: [],
    resultsHasMore: false,
    resultsLoading: true,
    resultsLoadingMore: false,
    query: '',
  }

  searcher;
  constructor(props) {
    super(props)
    this.searcher = SearchCache({
      getSearchResults: this.getSearchResults,
      onSearchResults: this.onSearchResults,
      debounce: this.props.delay
    })
  }

  getSearchResults = ({ query, offset }) => {
    this.setState({
      resultsLoading: offset === 0,
      resultsLoadingMore: offset > 0
    })
    return this.props.getSearchResults({ query, offset })
  }


  onSearchResults = ({ items, hasMore }, loadedMore) => {
    this.setState({ results: items, resultsHasMore: hasMore, resultsLoading: false, resultsLoadingMore: false })
  }


  onQueryChange = (query = '') => {
    this.setState({ query })
    this.searcher.getDebounced(query)
  }

  onSelected = selection => {
    this.props.onSelected(selection)
    this.onQueryChange(this.props.valueOnSelect(selection, this.state.query ))
  }


  render() {
    const {
      Render,
      onSelected,
      onForceSelect,
      getResults,
      delay,
      renderOption,
      getKey,
      placeholder,
      ...others
    } = this.props
    const {
      results,
      resultsHasMore,
      resultsLoading,
      resultsLoadingMore,
      query,
    } = this.state

    const {
      onQueryChange,
    } = this
    return <Render
      results={results}
      resultsHasMore={resultsHasMore}
      resultsLoading={resultsLoading}
      resultsLoadingMore={resultsLoadingMore}
      query={query}
      placeholder={placeholder}

      renderOption={renderOption}
      getKey={getKey}
      onSelected={this.onSelected}
      onForceSelect={onForceSelect}
      getMore={this.searcher.getMore}

      onQueryChange={onQueryChange}
      {...others}
    />
  }

}

